<template>
  <div class="order-success-page">
    <div class="success-container">
      <div class="success-icon">
        ✓
      </div>
      <h1>Order Placed Successfully!</h1>
      <p class="success-message">Thank you for your purchase. Your order has been received and is being processed.</p>
      <div class="order-details">
        <p>Payment Status: <span class="status-success">Success</span></p>
        <p>You will receive an email confirmation shortly.</p>
        <p class="countdown">Redirecting in {{ countdown }} seconds...</p>
      </div>
      <div class="action-buttons">
        <router-link to="/" class="continue-shopping">
          Continue Shopping
        </router-link>
        <router-link to="/purchases" class="view-orders">
          View My Orders
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../config';

export default {
  name: 'OrderSuccess',
  data() {
    return {
      countdown: 5
    }
  },
  mounted() {
    // Clear cart after successful order
    this.$store.commit('CLEAR_CART');
    localStorage.removeItem('cartWithParams');

    // Get user email from session endpoint
    axios.get(`${config.apiBaseUrl}/api/auth/check-session`, { withCredentials: true })
      .then(response => {
        const userEmail = response.data.user?.email;
        if (userEmail) {
          axios.post('/api/contact/order-success', { userEmail })
            .catch(err => {
              console.error('Failed to send order success email:', err);
            });
        }
      })
      .catch(err => {
        console.error('Failed to fetch user session:', err);
      });

    // Start countdown timer
    const safeGoPurchases = () => {
      if (this.$route.path === '/purchases') return; // already there
      this.$router.push('/purchases').catch(err => {
        // Ignore redundant navigation errors
        if (err && err.name !== 'NavigationDuplicated') {
          console.error('Navigation to /purchases failed:', err);
        }
      });
    };

    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer);
        safeGoPurchases();
      }
    }, 1000);
  }
}
</script>

<style scoped>
.order-success-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 2rem;
}

.success-container {
  background: white;
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.success-icon {
  font-size: 4rem;
  color: #4CAF50;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

h1 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 2rem;
}

.success-message {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.order-details {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 4px;
  margin-bottom: 2rem;
}

.status-success {
  color: #4CAF50;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.continue-shopping, .view-orders {
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.continue-shopping {
  background: #4CAF50;
  color: white;
}

.view-orders {
  background: #2196F3;
  color: white;
}

.continue-shopping:hover, .view-orders:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.countdown {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  .success-container {
    padding: 2rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .continue-shopping, .view-orders {
    width: 100%;
  }
}
</style> 